import API from '..';
const ENTITY = 'chats/alliance';

export const initChat = (allianceId) =>
    API.post(`/api/v1/${ENTITY}/${allianceId}`);
export const fetchMessages = (chatId) => API.get(`/api/v1/${ENTITY}/${chatId}`);
export const sendMessage = (chatId, data) =>
    API.post(`/api/v1/${ENTITY}/${chatId}/message/`, data);
